export const GET_STOCK_TRANSFER_LIST = 'GET_STOCK_TRANSFER_LIST';
export const SAVE_STOCK_TRANSFER = 'SAVE_STOCK_TRANSFER';
export const DELETE_STOCK_TRANSFER = 'DELETE_STOCK_TRANSFER';
export const STOCK_TRANSFER_ERROR = 'STOCK_TRANSFER_ERROR';
